/* @flow */
import ConfirmDialog from 'components/ConfirmDialog';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupName from 'groups/components/GroupName';
import PropTypes from 'prop-types';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';
import errorLogger from 'utils/errorLogger';

class GroupLeaveConfirmDialog extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    group: PropTypes.instanceOf(Group).isRequired,
    onLeave: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  unsubscribe = () => {
    const { group } = this.props;

    if (this.props.onLeave) {
      this.props.onLeave();
    }

    GroupActions.unsubscribeFromGroup(group)
      .then(() => {
        this.context.router.push('/classes');
        ToastActions.showSuccessToast(`You have left ${group.getName()}`);
      })
      .catch(e => {
        const errorMessage = e.message || `An error occured leaving ${group.getName()}.`;
        ToastActions.showErrorToast(errorMessage);
        errorLogger('GroupLeaveConfirmDialog unsubscribeFromGroup failed');
      });
  };

  render() {
    const { group } = this.props;

    const subtext = (
      <span>
        Once you leave, you will no longer receive messages from <GroupName group={group} />
      </span>
    );

    return (
      <ConfirmDialog
        eventScreenName="GroupLeaveConfirmDialog"
        {...this.props}
        actionButtonText="Leave"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.unsubscribe}
        title="Leave this class?"
        subtext={subtext}
      />
    );
  }
}

export default GroupLeaveConfirmDialog;
